import axios from '../../../axios'

// 列表
export const list = (data) => {
  return axios({
    url: 'plan/yearlyPlan/list',
    method: 'post',
    data
  })
}
// 详细列表
export const detailList = (data) => {
  return axios({
    url: 'plan/yearlyPlan/detailList',
    method: 'post',
    data
  })
}

// 编辑
export const edit = (data) => {
  return axios({
    url: 'plan/yearlyPlan/edit',
    method: 'post',
    data
  })
}
// 保存
export const save = (data) => {
  return axios({
    url: 'plan/yearlyPlan/save',
    method: 'post',
    data
  })
}
// 查看
export const view = (data) => {
  return axios({
    url: 'plan/yearlyPlan/view',
    method: 'post',
    data
  })
}
// 删除
export const batchDelete = (data) => {
  return axios({
    url: 'plan/yearlyPlan/delete',
    method: 'post',
    data
  })
}
// 获取每月养护次数
export const getPlanDaysData = (data) => {
  return axios({
    url: 'plan/yearlyPlan/getPlanDaysData',
    method: 'post',
    data
  })
}
// 获取下拉框数据
export const getSelectList = (data) => {
  return axios({
    url: 'plan/yearlyPlan/getSelectList',
    method: 'post',
    data
  })
}

// 获取单位/部门下的人员
export const getDeptUsers = (data) => {
  return axios({
    url: 'plan/yearlyPlan/getDeptUser',
    method: 'post',
    data
  })
}
// 获取单位下部门
export const getTeamByDeptId = (data) => {
  return axios({
    url: 'plan/yearlyPlan/getTeamByDeptId',
    method: 'post',
    data
  })
}
// 获取下拉框数据（养护单位，路段）
export const getSelectData = (data) => {
  return axios({
    url: 'plan/yearlyPlan/getSelectData',
    method: 'post',
    data
  })
}
// 根据养护单位获取养护路段
export const getUnitByProject = (data) => {
  return axios({
    url: 'plan/yearlyPlan/getUnitByProject',
    method: 'post',
    data
  })
}

// 下载
export const download = (data) => {
  return axios({
    url: 'plan/yearlyPlan/download',
    method: 'post',
    data,
    responseType: 'blob'
  }).then(res => {
    console.log(res)
    if(res){
      openDownloadDialog(res,data.name)
    }
  })
}

// 年度养护作业量
export const getYearPlanQuantity = (data) => {
  return axios({
    url: 'plan/yearlyPlan/getYearPlanQuantity',
    method: 'post',
    data
  })
}


// 列表
export const saveDelayPlan = (data) => {
  return axios({
    url: 'plan/yearlyPlan/saveDelayPlan',
    method: 'post',
    data
  })
}

function openDownloadDialog(url, saveName)
{
  if(typeof url == 'object' && url instanceof Blob)
  {
    url = URL.createObjectURL(url); // 创建blob地址
  }
  var aLink = document.createElement('a');
  aLink.href = url;
  aLink.download = saveName || ''; // HTML5新增的属性，指定保存文件名，可以不要后缀，注意，file:///模式下不会生效
  var event;
  if(window.MouseEvent) event = new MouseEvent('click');
  else
  {
    event = document.createEvent('MouseEvents');
    event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
  }
  aLink.dispatchEvent(event);
}






// WEBPACK FOOTER //
// ./src/http/moudules/biz/plan/yearlyPlan.js